import { fromJS } from 'immutable';

import { SUBMIT, SUBMIT_SUCCESS, SUBMIT_FAILED } from './types';

export const initialState = fromJS({
  submitting: false,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT:
      return state.set('submitting', true);

    case SUBMIT_SUCCESS:
      return state.set('submitting', false);

    case SUBMIT_FAILED:
      return state.set('submitting', false);

    default:
      return state;
  }
};
